import { message, Modal, Spin } from 'antd';
import queryString from 'query-string';
import { checkTokenApi, shieldLoginApi, thirdIdpLoginApi, thirdAttrIdpLoginApi, thirdGoogleIdpLoginApi, oidcBuildAuthCodeLoginApi } from '../../action';
import redirectUrl from '../../utils/redirectUrl';
import SimulatedForm from '../../utils/simulatedForm';
import { AUTH_TOKEN_NAME } from '../../const';

const getOtherConfig = ({ target, sp, id }) => {
    let host = '';
    let type = null; // 1: 神盾 2: 阿里云,火山 3: 华为 4: 蓝湖、mastergo
    if (/jaeger-tst\.shizhi-inc\.com/.test(target)) {
        type = 1;
        host = 'https://jaeger-tst.shizhi-inc.com';
    }
    if (/jaeger\.shizhi-inc\.com/.test(target)) {
        type = 1;
        host = 'https://jaeger.shizhi-inc.com';
    }
    if (/agiletc-tst\.shizhi-inc\.com/.test(target)) {
        type = 1;
        host = 'https://agiletc-tst.shizhi-inc.com';
    }
    if (/agiletc\.shizhi-inc\.com/.test(target)) {
        type = 1;
        host = 'https://agiletc.shizhi-inc.com';
    }
    // 阿里云、火山
    if (['aliyun', 'volc'].includes(sp)) {
        type = 2;
    }
    // 华为
    if (['hw', 'jz-hw'].includes(sp)) {
        type = 3;
    }
    // 蓝湖、mastergo
    if (['lanhu', 'mastergo'].includes(sp)) {
        type = 4;
    }
    // oidc登录
    if (id) {
        type = 5;
    }
    return {
        host,
        type
    }
}

// 神盾登录
const aegisLogin = async ({ host, goto, authorization }) => {
    SimulatedForm(`${host}/sso/api/shield/login`, {
        goto,
        authorization
    });
    // await shieldLoginApi({
    //     host,
    //     goto,
    //     authorization
    // })
};

// 阿里云、火山登录
const aliyunVolcLogin = async ({ sp }) => {
    const params = queryString.parse(window.location.search.split('?')[1] || '');
    let goto = params.RelayState;
    if (sp === 'volc') {
        // 处理链接不合规特殊逻辑
        const arr = (params.RelayState || '').split('//');
        // 处理链接不合规特殊逻辑
        goto = `https://${arr[arr.length - 1]}`;
    }
    const res = await thirdIdpLoginApi({
        sp,
        code: params.SAMLRequest,
        goto: goto
    });
    if (res.data.code === 0) {
        goSAMLLogin(res);
    } else {
        message.error(res.data.msg);
    }
}

// 华为登录
const hwLogin = async ({ sp }) => {
    const params = queryString.parse(window.location.search.split('?')[1] || '');
    const res = await thirdAttrIdpLoginApi({
        sp,
        code: params.SAMLRequest,
        goto: params.RelayState,
        sig_alg: params.sig_alg,
        signature: params.signature,
    })
    if (res.data.code === 0) {
        goSAMLLogin(res);
    } else {
        message.error(res.data.msg);
    }
}

// 蓝湖、mastergo登录
const lanhuMastergoLogin = async ({ sp }) => {
    const params = queryString.parse(window.location.search.split('?')[1] || '');
    const res = await thirdGoogleIdpLoginApi({
        sp,
        code: params.SAMLRequest,
        goto: params.RelayState,
        sig_alg: params.sig_alg,
        signature: params.signature,
    })
    if (res.data.code === 0) {
        goSAMLLogin(res);
    } else {
        message.error(res.data.msg);
    }
}

// 阿波罗登录
const oidcLogin = async () => {
    const params = queryString.parse(window.location.search.split('?')[1] || '');
    const res = await oidcBuildAuthCodeLoginApi({
        id: params.id
    });
    if (res.data.code === 0) {
        goOIDCLogin(res.data.data);
    } else {
        message.error(res.data.msg);
    }
}

// SAML去登录
const goSAMLLogin = (res) => {
    const { url, code, goto } = res.data.data || {};
    SimulatedForm(url, {
        'SAMLResponse': code,
        'RelayState': goto
    });
}

// OIDC去登录
const goOIDCLogin = (target) => {
    redirectUrl({
        target
    })
}

export default {
    // 检查主token是否有效
    checkMainToken: ({ target, sp, id }) => {
        let modal = null;
        const { host, type } = getOtherConfig({ target, sp, id });
        const autoLogin = async () => {
            const AUTH_TOKEN = localStorage.getItem(AUTH_TOKEN_NAME) || '';
            const res = await checkTokenApi();
            if (res.data.code === 0) {
                if (type === 1) {
                    aegisLogin({
                        host,
                        goto: target,
                        authorization: AUTH_TOKEN
                    });
                    return false;
                }
                if (type === 2) {
                    aliyunVolcLogin({
                        sp
                    });
                    return false;
                }
                if (type === 3) {
                    hwLogin({
                        sp
                    })
                    return false;
                }
                if (type === 4) {
                    lanhuMastergoLogin({
                        sp
                    })
                    return false;
                }
                if (type === 5) {
                    oidcLogin()
                    return false;
                }
            }
            // message.info('主站授权信息获取失败，请重新登录');
            modal && modal.destroy();
            return true;
        }
        if (type) {
            modal = Modal.info({
                icon: null,
                title: "",
                width: 200,
                centered: true,
                content: <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Spin size="large" />
                    <span style={{ marginTop: 20 }}>正在获取主站授权信息</span>
                </div>,
                footer: false
            });
            return autoLogin();
        } else {
            return true;
        }
    },
    // 登录其他站点
    loginOtherSite: ({ target, sp, id }) => {
        const AUTH_TOKEN = localStorage.getItem(AUTH_TOKEN_NAME) || '';
        const { host, type } = getOtherConfig({ target, sp, id });
        if (type === 1) {
            aegisLogin({
                host,
                goto: target,
                authorization: AUTH_TOKEN
            });
            return false;
        }
        if (type === 2) {
            aliyunVolcLogin({
                sp
            });
            return false;
        }
        if (type === 3) {
            hwLogin({
                sp
            })
            return false;
        }
        if (type === 4) {
            lanhuMastergoLogin({
                sp
            })
            return false;
        }
        if (type === 5) {
            oidcLogin()
            return false;
        }
        return true;
    }
};